import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NavaidModel } from 'src/app/models/navaid';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { PointsService } from 'src/app/services/points.service';
import { HttpClient } from '@angular/common/http';
import { ModalControlService } from 'src/app/services/modal-control.service';
import * as fileSaver from 'file-saver';
import { DuplicateNavaidsComponent } from '../duplicate-navaids/duplicate-navaids.component';
import { NavaidsService } from 'src/app/services/navaids.service';
import { ChannelFreqObject } from 'src/app/models/ChannelFreqObject';
import { FreqConversionUtil } from 'src/app/models/FreqConversionUtil';

@Component({
  selector: 'app-frequency-corrected-navaids',
  templateUrl: './frequency-corrected-navaids.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class FrequencyCorrectedNavaidsComponent implements OnInit {

  @Input()
  duplicates:NavaidModel[] = [];

  @Input()
  navaids:NavaidModel[];


  constructor(public bsModalRef: BsModalService,
    public pointsService: PointsService,
    private endpointService: EndpointsService,
    private http: HttpClient,
    private modalControlService: ModalControlService,
    private navaidsService: NavaidsService) { }

  ngOnInit(): void {
  }
  cancel():void{
    this.bsModalRef.hide();
  }


  public static importCheckForCorrections(navaids:NavaidModel[],modalService:BsModalService,pointsController:PointsService, navaidsController : NavaidsService){
    let correctedList:NavaidModel[] = FrequencyCorrectedNavaidsComponent.getListOfCorrectedFrequencyNavaids(navaids);
    if(correctedList.length>0){ //frequency corrected navaids exist
      const bsRef:BsModalRef = modalService.show(FrequencyCorrectedNavaidsComponent);
      correctedList.sort((a, b) => a.navaidid.localeCompare(b.navaidid));
      bsRef.content.duplicates = FrequencyCorrectedNavaidsComponent.getFrequencies(correctedList);
      bsRef.content.navaids = navaids;
    }
    else{
      DuplicateNavaidsComponent.importCheckForDuplicates(navaids,modalService,pointsController, navaidsController,"XML");
    }
  }

  public static getListOfCorrectedFrequencyNavaids(navaids:NavaidModel[]): NavaidModel[]{
    const toReturn: NavaidModel[] = [];
    for (const nav of navaids){
      nav.eadFrequencyCorrected? toReturn.push(nav): false;
    }
    return toReturn;
  }

  static getFrequencies(navaids:NavaidModel[]){
    let toReturn: NavaidModel[] = [];
    navaids.forEach((navaid)=>
      {
        // define VHF tunning frequencia based on channel field
        let freq : ChannelFreqObject = FreqConversionUtil.findByChannel(navaid.channel);
        navaid.vhfTunFreqInput = freq != null &&  freq.vorFreq != null ? freq.vorFreq.toString() : null;
        toReturn.push(navaid);
      }
    )
    return toReturn;
}

  proceedWithImport(){
    //this.bsModalRef.hide();
    DuplicateNavaidsComponent.importCheckForDuplicates(this.navaids,this.bsModalRef,this.pointsService, this.navaidsService,"XML");
  }


  exportNavaidsToCsv(){
    this.http.post(this.endpointService.duplicatedNavaidsCSVUrl,
      JSON.stringify(this.duplicates),
      this.endpointService.fileHttpOptions
      ).subscribe(
        (blob:Blob) => {
          fileSaver.saveAs(blob, "navaidFile.csv");
        },
        (error) => {
          this.modalControlService.showMesssageModal("error","Error generating csv file");
        }
      )
  }

}
